import { Site } from '@envato/foundation-types'
import get from 'lodash-es/get'
import isEmpty from 'lodash-es/isEmpty'
import pick from 'lodash-es/pick'

import sitesConfig from '../../config/sites'
import { ICommonLocation } from './location/types'

export const getLocationFeaturesConfig = (
  featuresConfig: any,
  location: ICommonLocation
) => {
  const locationString = get(location, 'query.features', '')
  const locationArray = locationString
    .split(',')
    .filter((value: any) => !isEmpty(value))
  const locationConfig = locationArray.reduce(
    (config: any, featureName: string) => {
      if (featureName[0] === '!') {
        featureName = featureName.slice(1)
        config[featureName] = false
        return config
      }

      config[featureName] = true
      return config
    },
    {}
  )
  return pick(locationConfig, Object.keys(featuresConfig))
}

export const getSitesFeaturesConfig = (currentSite: Site) => {
  const defaultConfig = get(sitesConfig, 'defaults.features', {})
  const siteConfig = get(sitesConfig, `${currentSite}.features`, {})

  return {
    ...defaultConfig,
    ...siteConfig
  }
}

export const getExperimentsFeaturesConfig = (
  currentSite: Site,
  activeExperimentsState: any
) => {
  const defaultConfig = get(sitesConfig, 'defaults.experiments_to_features', {})
  const siteConfig = get(
    sitesConfig,
    `${currentSite}.experiments_to_features`,
    {}
  )
  const experimentsToFeaturesConfig = {
    ...defaultConfig,
    ...siteConfig
  }

  return Object.keys(experimentsToFeaturesConfig).reduce(
    (featuresConfig: any, experimentId: string) => {
      let variantFeaturesConfig = {}
      const activeExperimentState = activeExperimentsState[experimentId]

      if (activeExperimentState) {
        const experimentVariant = activeExperimentState.variant || 0
        const experimentFeaturesConfig =
          experimentsToFeaturesConfig[experimentId] || {}
        variantFeaturesConfig = experimentFeaturesConfig[experimentVariant]
      }
      return {
        ...featuresConfig,
        ...variantFeaturesConfig
      }
    },
    {}
  )
}

export const getFeaturesConfig = (
  currentSite: Site,
  location: ICommonLocation,
  experimentsState: any
) => {
  const mainConfig = getSitesFeaturesConfig(currentSite)
  const experimentsConfig = getExperimentsFeaturesConfig(
    currentSite,
    experimentsState
  )
  const locationConfig = getLocationFeaturesConfig(mainConfig, location)
  return {
    ...mainConfig,
    ...experimentsConfig,
    ...locationConfig
  }
}

export const hasFeature = (
  name: string,
  currentSite: Site,
  location: ICommonLocation,
  experimentsState: any = {}
): boolean => {
  return !!getFeaturesConfig(currentSite, location, experimentsState)[name]
}
